import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import RecordList from '../entities/inoutstockrecord'
import appconst from '@/lib/appconst';


interface RecordState extends ListState<RecordList> {


}

class FrontStockMutations extends ListMutations<RecordList>{

}
class Record extends ListModule<RecordState, any, RecordList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<RecordList>(),
        loading: false,
        id: 0,
        sku: ''
    }
    actions = {
        async getInOutStockRecordList(context: ActionContext<RecordState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontStockProduct/GetInOutStockRecord', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<RecordList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;

        },

    };
    mutations = {
        setCurrentPage(state: RecordState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: RecordState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const records = new Record();
export default records;